"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeStripeShippingLines = void 0;
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
const src_1 = require("..");
function changeStripeShippingLines(event) {
    return __awaiter(this, void 0, void 0, function* () {
        const shippingOption = event.shippingOption;
        const response = yield (0, checkout_frontend_library_1.changeShippingLine)(shippingOption.id, src_1.API_RETRY);
        const displayItems = (0, src_1.getPaymentRequestDisplayItems)();
        if (response.success) {
            const { order_total } = (0, checkout_frontend_library_1.getApplicationState)();
            const total = {
                label: 'Total',
                amount: order_total
            };
            event.updateWith({
                total: total,
                status: 'success',
                displayItems: displayItems
            });
        }
        else {
            event.updateWith({
                status: 'fail'
            });
        }
    });
}
exports.changeStripeShippingLines = changeStripeShippingLines;
